export default __webpack_public_path__ + "static/media/submit-pop-img.17a43dcb.gif";